import { useState } from 'react';

const faqs = [
  {
    q: '吃瓜视频在线观看是什么平台？',
    a: '吃瓜视频在线观看是一个汇聚51吃瓜在线、吃瓜在线等多平台的娱乐八卦资讯聚合站点。我们每日更新最新最全的吃瓜内容，涵盖娱乐圈、网红圈、综艺、影视和社会热点等多个领域，满足吃瓜群众在线的浏览需求。',
  },
  {
    q: '需要注册才能浏览内容吗？',
    a: '完全不需要！所有吃瓜内容均可免费浏览，无需注册或登录。我们重视每一位吃瓜群众的隐私，让你可以安心在线吃瓜，不留下任何浏览记录。',
  },
  {
    q: '内容更新频率是怎样的？',
    a: '瓜田每日更新，全天候滚动更新最新八卦资讯。我们的编辑团队实时监控全网热点，确保你不错过任何一条重要吃瓜内容，平均每日新增300+条信息。',
  },
  {
    q: '如何投稿或爆料？',
    a: '如果你有一手八卦消息或独家爆料，欢迎通过页面上的"投稿与爆料"栏目联系我们。发送邮件至投稿邮箱或添加微信联系，所有投稿来源严格保密。',
  },
  {
    q: '51吃瓜在线和吃瓜在线有什么区别？',
    a: '51吃瓜在线和吃瓜在线都是优质的吃瓜内容平台。本网站作为聚合平台，同时汇聚了这两个平台以及其他主流吃瓜平台的精华内容，让你在一个地方就能看到全网最全的八卦资讯。',
  },
  {
    q: '手机端可以正常访问吗？',
    a: '当然可以！我们的网站针对移动端做了专门的适配优化，在手机浏览器上访问体验同样流畅。无论你是在电脑前还是拿着手机，都能随时随地满足在线吃瓜需求。',
  },
];

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState(0);

  return (
    <section id="faq" className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1400px] mx-auto">
        <div className="text-center mb-10">
          <span className="text-xs font-label text-primary-600 bg-primary-50 px-3 py-1 rounded-full">答疑解惑</span>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mt-3">
            常见问题
          </h2>
          <p className="text-sm text-foreground-500 mt-2 max-w-[560px] mx-auto">
            关于吃瓜视频在线观看的常见疑问解答
          </p>
        </div>

        <div className="max-w-[720px] mx-auto flex flex-col gap-3">
          {faqs.map((faq, idx) => (
            <div
              key={idx}
              className="rounded-xl border border-background-200/60 bg-background-50 overflow-hidden"
            >
              <button
                onClick={() => setOpenIndex(openIndex === idx ? -1 : idx)}
                className="w-full flex items-center justify-between p-5 text-left cursor-pointer hover:bg-background-50 transition-colors"
              >
                <h3 className="text-sm font-label font-medium text-foreground-900 pr-4">
                  {faq.q}
                </h3>
                <div className={`flex-shrink-0 w-8 h-8 flex items-center justify-center rounded-lg transition-all ${
                  openIndex === idx ? 'bg-primary-100 text-primary-600 rotate-180' : 'bg-background-100 text-foreground-400'
                }`}>
                  <i className="ri-arrow-down-s-line"></i>
                </div>
              </button>
              <div
                className={`transition-all duration-300 overflow-hidden ${
                  openIndex === idx ? 'max-h-[500px] opacity-100' : 'max-h-0 opacity-0'
                }`}
              >
                <div className="px-5 pb-5">
                  <p className="text-sm text-foreground-600 leading-relaxed">
                    {faq.a}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}